import { mapMutations, mapState } from "vuex";
export default {
  data() {
    return {
      name: 'storeMix'
    }
  },
  created() {

  },
  mounted() {},
  methods: {
    ...mapMutations(["changeSysConfig"]),
  },
  computed: {
    ...mapState({
      sysConfig: "sysConfig",
    }),
  },
}


// WEBPACK FOOTER //
// ./src/mixins/storeMix.js